import type { PopupID } from 'src/game/components/popups/popupRegistry';

export const dialogOpenBlacklist: ReadonlySet<PopupID> = new Set<PopupID>([
  'popupStreakBattleRoyaleV2',
  'popupGenericInviteFriends',
  'popupMatch2DailyChallenge',
  'popupFriendsList',
  'popupEnergyShop',
  'popupTreasureExpress',
  'popupGiftsList',
]);

export function shouldTrackDialogOpen(id: PopupID): boolean {
  return !dialogOpenBlacklist.has(id);
}
